import { render } from "./HelloWorld.vue?vue&type=template&id=cf574652&scoped=true"
import script from "./HelloWorld.vue?vue&type=script&lang=ts"
export * from "./HelloWorld.vue?vue&type=script&lang=ts"

import "./HelloWorld.vue?vue&type=style&index=0&id=cf574652&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-cf574652"

export default script